import { OPEN_MODAL, HIDE_MODAL, UPDATE_MODAL_PROP, UPDATE_OBJEKT_MODAL_PROP } from '../actions/modal'

const state = {
  modals: []
}

const getters = {
  getStack: state => state.modals,
  haveModals: state => state.modals.length > 0,
  getCurrentModal: state => state.modals.length > 0 ? state.modals[0] : null
}

const actions = {
  [OPEN_MODAL]: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit(OPEN_MODAL, payload)
    })
  },

  [HIDE_MODAL]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(HIDE_MODAL)
    })
  },

  [UPDATE_MODAL_PROP]: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit(UPDATE_MODAL_PROP, payload)
    })
  },
  [UPDATE_OBJEKT_MODAL_PROP]: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit(UPDATE_OBJEKT_MODAL_PROP, payload)
    })
  }
}

const mutations = {
  [OPEN_MODAL]: (state, payload) => {
    let data = {}

    data.modalName = payload.modalName
    data.modalProps = payload.modalProps || {}
    data.modalOnCloseEvent = payload.modalOnCloseEvent || null

    if (payload.modalType === 'left') {
      data.modalType = 'left'
    } else if (payload.modalType === 'right') {
      data.modalType = 'right'
    } else if (payload.modalType === 'top') {
      data.modalType = 'top'
    } else if (payload.modalType === 'bottom') {
      data.modalType = 'bottom'
    } else if (payload.modalType === 'fullscreen') {
      data.modalType = 'fullscreen'
    } else if (payload.modalType === 'medium') {
      data.modalType = 'medium'
    } else if (payload.modalType === 'large') {
      data.modalType = 'large'
    } else if (payload.modalType === 'split') {
      data.modalType = 'split'
    } else if (payload.modalType === 'fullsplit') {
      data.modalType = 'fullsplit'
    } else if (payload.modalType === 'confirm') {
      data.modalType = 'small'
    } else {
      data.modalType = null
    }

    // Prepend modal - i.e. add to top of array
    state.modals.unshift(data)
  },
  [HIDE_MODAL]: (state) => {
    if (state.modals.length > 0) {
      state.modals.shift()
    }
  },
  [UPDATE_MODAL_PROP]: (state, payload) => {
    if (state.modals.length > 0) {
      let current = state.modals[0]

      if (current.modalProps) {
        current.modalProps = Object.assign({}, current.modalProps, payload)
      }
    }
  },
  [UPDATE_OBJEKT_MODAL_PROP]: (state, payload) => {
    if (state.modals.length > 0) {
      let found = state.modals.find(i => i.modalName === 'kunde-kontrakt-objekt')

      if (found && found.modalProps) {
        found.modalProps = Object.assign({}, found.modalProps, payload)

        console.log('Just updated obj modal props')
      }
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js